import React from 'react';
import styled, { css } from 'styled-components';
import Button, { BUTTON_OPTIONS } from '../../../common/atoms/Button';
import Icon, { ICON_OPTIONS } from '../../../common/atoms/Icon';
import useOpenModalButtonLogic from './useOpenModalButtonLogic';

const OPEN_MODAL_BUTTON_CONSTS = {
  BUTTON_TEXT: 'Go',
  BUTTON_SIZE: BUTTON_OPTIONS.SIZES.MD,
  DEFAULT_TEXT: 'Search for local businesses...',
  ICON: 'keywordSearch',
  ICON_COLOR: ICON_OPTIONS.COLORS.PRIMARY,
  ICON_SIZE: ICON_OPTIONS.SIZES.LG,
};

const StyledRoot = styled.div`
  align-items: center;
  background-color: ${props => props.theme.background.background100};
  border: none;
  border-radius: 22px;
  box-shadow: ${props => props.theme.shadows[6]};
  cursor: pointer;
  display: flex;
  height: 44px;
  padding: ${props => `
    ${props.theme.padding.small}
    ${props.theme.padding.small}
    ${props.theme.padding.small}
    ${props.theme.padding.medium}
  `};
  width: 100%;
`;

const StyledText = styled.span`
  flex: 1;
  font-size: ${props => props.theme.fontSize.normal};
  padding: 0 ${props => props.theme.padding.small};
  margin-left: ${props => props.theme.margin.xsmall};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /** HAS VALUE */
  ${props =>
    props.hasValue
      ? css`
          color: ${props.theme.text.normal};
        `
      : css`
          color: ${props.theme.text.text400};
        `}
`;

const StyledIcon = styled(Icon)`
  font-weight: 900;
`;

const OpenModalButton = () => {
  const {
    handleClick,
    handleButtonClick,
    hasValue,
    showButton,
    text,
  } = useOpenModalButtonLogic({
    defaultText: OPEN_MODAL_BUTTON_CONSTS.DEFAULT_TEXT,
  });

  return (
    <StyledRoot onClick={handleClick}>
      <StyledIcon
        color={OPEN_MODAL_BUTTON_CONSTS.ICON_COLOR}
        icon={OPEN_MODAL_BUTTON_CONSTS.ICON}
        size={OPEN_MODAL_BUTTON_CONSTS.ICON_SIZE}
      />
      <StyledText hasValue={hasValue}>{text}</StyledText>
      {showButton && (
        <Button
          handleClick={handleButtonClick}
          size={OPEN_MODAL_BUTTON_CONSTS.BUTTON_SIZE}
          text={OPEN_MODAL_BUTTON_CONSTS.BUTTON_TEXT}
        />
      )}
    </StyledRoot>
  );
};

export default OpenModalButton;
